import React, { useRef, useEffect } from "react";
import { PropTypes } from "prop-types";
import {
  Heading,
  SubHead,
  FundLeft,
  FundRight,
  InputWrap,
  FundNameWrap,
} from "../styles";
import InputComponent from "./InputComponent";
import { connect } from "react-redux";
import {
  handleInputChange,
  handleError,
  jsonTemp,
  toggleStepTwoUpdateButton,
  validationHandler,
} from "../../actions";
import { ErrLength } from "./styles";
import regexMap from "../../../../../utils/regexMap";
import { AccountNameDerivedStates } from "../../selectors";

const changeValidationCheck = (props) => {
  props.validationHandler(false);
};

const changeValidationCheckToTrue = (props) => {
  props.validationHandler(true);
};

export const handleBlur = (e, props) => {
  let arr = null;
  let len = null;
  if (e) {
    let trimName = e.trim();
    arr = trimName.split(" ");
    len = arr.length;
  }

  let reg = /^(?=(.*[0-9]){2,})|(?=(.*[A-Za-z]){2,}).*/;
  let fundNameIssue = false;
  if (arr != null) {
    if (
      arr[0].toLowerCase() === "the" ||
      arr[arr.length - 1].toLowerCase() === "fund"
    ) {
      fundNameIssue = true;
    }
  }

  if (e == undefined || e == "") {
    changeValidationCheck(props);
    props.handleError({
      accountNameError: <ErrLength>Please enter account name</ErrLength>,
    });
  } else if (e.length < 2) {
    changeValidationCheck(props);
    props.handleError({
      accountNameError: (
        <ErrLength>Account name is too short. Please try again</ErrLength>
      ),
    });
  } else if (!reg.test(e)) {
    changeValidationCheck(props);
    props.handleError({
      accountNameError: (
        <ErrLength>Please use at least two letters or two numbers.</ErrLength>
      ),
    });
  } else if (fundNameIssue) {
    changeValidationCheck(props);
    props.handleError({
      accountNameError: <ErrLength>Remove the word "The" and "Fund"</ErrLength>,
    });
  } else if (
    e.toLowerCase().includes("trust") ||
    e.toLowerCase().includes("endowment") ||
    e.toLowerCase().includes("foundation")
  ) {
    changeValidationCheck(props);
    props.handleError({
      accountNameError: (
        <ErrLength>
          Account name cannot use the words 'trust', 'endowment' or
          'foundation'. Please try again
        </ErrLength>
      ),
    });
  } else if (regexMap.eliminateSpecialCharacter.test(e)) {
    changeValidationCheck(props);
    let errorContent =
      "The following special characters are not allowed : |, <, >.";
    props.handleError({
      accountNameError: <ErrLength>{errorContent}</ErrLength>,
    });
  } else {
    changeValidationCheckToTrue(props);
    props.handleError({
      accountNameError: null,
    });
  }
};

export const handleInput = (e, props) => {
  if (props.stepperUpdateIndex.status) {
    props.toggleStepTwoUpdateButton(true);
  }
  if (props.isStep2Edit) {
    let tempData = props.tempData.tempJSON;
    tempData.fundName = e.target.value;
    props.jsonTemp({
      tempJSON: tempData,
      enableReset: true,
    });
  } else {
    props.handleInputChange({
      fundName: e.target.value,
    });
  }
  if (e.target.value.length > 0) {
    props.handleError({
      accountNameError: null,
    });
  }
};

export const AccountName = (props) => {
  const nameInput = useRef(null);
  useEffect(() => {
    nameInput.current.focus();
  }, []);

  return (
    <div>
      <Heading role={false} marginBottom="10px">Name your philanthropic account</Heading>
      <SubHead>
        The name you choose may not include the words trust, endowment, fund or
        foundation. We maintain the right to deny a requested account name if it
        doesn’t fit our requirements. All account assets are the property of
        Vanguard Charitable.
      </SubHead>
      <FundNameWrap className="fundNameWraper">
        <FundLeft>The</FundLeft>
        <InputWrap className="fundNameWraper">
          <InputComponent
            id="accnt_name"
            ariaLabel="fundName"
            value={
              props.isStep2Edit
                ? props.tempData.tempJSON.fundName
                : props.fundName
            }
            handleBlur={
              props.isStep2Edit
                ? (e) => handleBlur(props.tempData.tempJSON.fundName, props)
                : (e) => handleBlur(props.fundName, props)
            }
            handleInputChange={(e) => handleInput(e, props)}
            max={71}
            inputRef={nameInput}
            ariaLabel="Enter Fund Name"
          />
          {props.accountNameError ? props.accountNameError : null}
        </InputWrap>
        <FundRight>Fund</FundRight>
      </FundNameWrap>
    </div>
  );
};

const mapStateToProps = (state) => ({
  ...AccountNameDerivedStates(state.toJS()),
});

export const mapDispatchToProps = (dispatch) => ({
  handleInputChange: (val) => dispatch(handleInputChange(val)),
  handleError: (val) => dispatch(handleError(val)),
  jsonTemp: (val) => dispatch(jsonTemp(val)),
  toggleStepTwoUpdateButton: (val) => dispatch(toggleStepTwoUpdateButton(val)),
  validationHandler: (val) => dispatch(validationHandler(val)),
});

AccountName.propTypes = {
  accountNameError: PropTypes.any,
  fundName: PropTypes.string,
  handleError: PropTypes.func,
  handleInputChange: PropTypes.func,
  isStep2Edit: PropTypes.any,
  jsonTemp: PropTypes.func,
  stepperUpdateIndex: PropTypes.object,
  tempData: PropTypes.any,
  toggleStepTwoUpdateButton: PropTypes.func,
  validationHandler: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountName);
